import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Container, Navbar, Nav, Row, Col } from 'react-bootstrap';
import TopBanner from '../../components/topBanner';
import startIcon from '../../assets/img/star-orange.svg';
import PlansWidget from '../../components/plansWidget';
import ExtendedPlansWidget from '../../components/extendedPlansWidget';
import FeaturesWidget from '../../components/featuresWidget';
import HostingWidget from '../../components/hostingWidget';
import CpanelWidget from '../../components/cpanelWidget';
import SwitchWidget from '../../components/switchWidget';
import FaqWidget from '../../components/faqWidget';
import ContactBanner from '../../components/contactBanner/ContactBanner';
import webBannerEn from '../../assets/img/web-banner-en.svg';
import webBannerFr from '../../assets/img/web-banner-fr.svg';
import releaseIcon from '../../assets/img/release-icon.svg';
import checkmarkIcon from '../../assets/img/checkmark.svg';
import infoBanner1 from '../../assets/img/info-banner-1.svg';
import infoBanner2 from '../../assets/img/info-banner-2.svg';
import infoBanner3 from '../../assets/img/info-banner-3.svg';
import { SmoothScrollLink } from '../../utils/navUtils';
import './hostingWeb.scss';

function HostingWebPage() {
    const { i18n, t } = useTranslation();
    const currentLanguage = i18n.language;
    const isFR = currentLanguage === 'fr';
    const localizedPath = (path) => {
        const baseLangUrl = `/${currentLanguage}`;
        return baseLangUrl + path;
    };

    return (
        <>
            <Helmet>
                <title>{t('titles.hosting-web')}</title>
            </Helmet>
            <div className="hosting-page-wrapper">
                <TopBanner
                    bannerImage={
                        <img src={isFR ? webBannerFr : webBannerEn} alt="Web hosting banner" />
                    }
                    className="web-top-banner"
                >
                    <>
                        <h1 className="banner-header">{t('web-hosting-page.top-banner.title')}</h1>
                        <h2
                            className="banner-sub-header"
                            dangerouslySetInnerHTML={{
                                __html: t('web-hosting-page.top-banner.text')
                            }}
                        />
                        <ul className="banner-list">
                            <li className="banner-item">
                                <img src={releaseIcon} alt="List item" />
                                <p className="banner-text">
                                    {t('web-hosting-page.top-banner.list-1')}
                                </p>
                            </li>
                            <li className="banner-item">
                                <img src={releaseIcon} alt="List item" />
                                <p className="banner-text">
                                    {t('web-hosting-page.top-banner.list-2')}
                                </p>
                            </li>
                            <li className="banner-item">
                                <img src={releaseIcon} alt="List item" />
                                <p className="banner-text">
                                    {t('web-hosting-page.top-banner.list-3')}
                                </p>
                            </li>
                        </ul>
                        <hr className="banner-separator" />
                        <div className="banner-badges">
                            <span className="single-badge">
                                <img src={startIcon} alt="Star" />
                                {t('titles.free-domain')}
                            </span>
                            <span className="single-badge">
                                <img src={startIcon} alt="Star" />
                                {t('titles.free-ssl')}
                            </span>
                        </div>
                        <div className="banner-actions">
                            <Nav>
                                <SmoothScrollLink to={localizedPath('/hosting/web#plans-section')}>
                                    <Navbar.Brand>{t('buttons.order-hosting')}</Navbar.Brand>
                                </SmoothScrollLink>
                            </Nav>
                            <div className="action-info">
                                <img src={checkmarkIcon} alt="Checkmark" />
                                <p className="action-text">{t('banners.top-banner-money-back')}</p>
                            </div>
                        </div>
                    </>
                </TopBanner>
                <section className="info-banner">
                    <Container>
                        <Row>
                            <Col lg={4}>
                                <div className="info-banner-block">
                                    <img
                                        className="info-image"
                                        src={infoBanner1}
                                        alt="Info banner"
                                    />
                                    <h3 className="info-banner-title">
                                        {t('banners.info-banner-web.col-1-text')}
                                    </h3>
                                </div>
                            </Col>
                            <Col lg={4}>
                                <div className="info-banner-block">
                                    <img
                                        className="info-image"
                                        src={infoBanner2}
                                        alt="Info banner"
                                    />
                                    <h3 className="info-banner-title">
                                        {t('banners.info-banner-web.col-2-text')}
                                    </h3>
                                </div>
                            </Col>
                            <Col lg={4}>
                                <div className="info-banner-block">
                                    <img
                                        className="info-image"
                                        src={infoBanner3}
                                        alt="Info banner"
                                    />
                                    <h3 className="info-banner-title">
                                        {t('banners.info-banner-web.col-3-text')}
                                    </h3>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <section className="section-wrapper plans-section" id="plans-section">
                    <Container>
                        <div className="section-top">
                            <h2
                                className="section-title"
                                dangerouslySetInnerHTML={{
                                    __html: t('web-hosting-page.plans-title')
                                }}
                            />
                            <p className="section-text">{t('web-hosting-page.plans-text')}</p>
                        </div>
                        <PlansWidget />
                    </Container>
                </section>
                <section className="section-wrapper features-section">
                    <Container>
                        <div className="section-top">
                            <h2
                                className="section-title"
                                dangerouslySetInnerHTML={{
                                    __html: t('web-hosting-page.features-title')
                                }}
                            />
                            <p className="section-text">{t('web-hosting-page.features-text')}</p>
                        </div>
                        <FeaturesWidget />
                    </Container>
                </section>
                <section className="section-wrapper hosting-section">
                    <Container>
                        <div className="section-top">
                            <h2
                                className="section-title"
                                dangerouslySetInnerHTML={{
                                    __html: t('web-hosting-page.hosting-title')
                                }}
                            />
                            <p className="section-text">{t('web-hosting-page.hosting-text')}</p>
                        </div>
                        <HostingWidget />
                    </Container>
                </section>
                <section className="regular-banner p-5">
                    <h3 className="banner-title">{t('banners.regular-banner-web-text')}</h3>
                </section>
                <section className="section-wrapper cpanel-section">
                    <Container>
                        <div className="section-top">
                            <h2
                                className="section-title"
                                dangerouslySetInnerHTML={{
                                    __html: t('web-hosting-page.cpanel-title')
                                }}
                            />
                            <p className="section-text">{t('web-hosting-page.cpanel-text')}</p>
                        </div>
                        <CpanelWidget />
                    </Container>
                </section>
                <section className="section-wrapper switch-section">
                    <Container>
                        <div className="section-top">
                            <h2
                                className="section-title"
                                dangerouslySetInnerHTML={{
                                    __html: t('web-hosting-page.switch-title')
                                }}
                            />
                            <p className="section-text">{t('web-hosting-page.switch-text')}</p>
                        </div>
                        <SwitchWidget />
                    </Container>
                </section>
                <section className="section-wrapper extended-plans-section" id="all-plans-section">
                    <Container>
                        <div className="section-top">
                            <h2
                                className="section-title"
                                dangerouslySetInnerHTML={{
                                    __html: t('web-hosting-page.extended-plans-title')
                                }}
                            />
                            <p className="section-text">
                                {t('web-hosting-page.extended-plans-text')}
                            </p>
                        </div>
                        <ExtendedPlansWidget />
                    </Container>
                </section>
                <section className="section-wrapper faq-section">
                    <Container>
                        <div className="section-top">
                            <h2
                                className="section-title"
                                dangerouslySetInnerHTML={{
                                    __html: t('web-hosting-page.faq-title')
                                }}
                            />
                            <p className="section-text">{t('web-hosting-page.faq-text')}</p>
                        </div>
                        <FaqWidget />
                    </Container>
                </section>
                <ContactBanner />
            </div>
        </>
    );
}

export default HostingWebPage;
